import React from 'react';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const FilterPanel = ({
  filters,
  onFilterChange,
  onClearFilters,
  resultCount,
  isOpen,
  onToggle
}) => {
  const categoryOptions = [
    { value: 'all', label: 'All Categories' },
    { value: 'strength', label: 'Strength Training' },
    { value: 'cardio', label: 'Cardio' },
    { value: 'flexibility', label: 'Flexibility' },
    { value: 'hiit', label: 'HIIT' },
    { value: 'yoga', label: 'Yoga' },
    { value: 'pilates', label: 'Pilates' }
  ];

  const difficultyOptions = [
    { value: 'all', label: 'All Levels' },
    { value: 'beginner', label: 'Beginner' },
    { value: 'intermediate', label: 'Intermediate' },
    { value: 'advanced', label: 'Advanced' }
  ];

  const durationOptions = [
    { value: 'all', label: 'Any Duration' },
    { value: '0-15', label: 'Under 15 min' },
    { value: '15-30', label: '15-30 min' },
    { value: '30-45', label: '30-45 min' },
    { value: '45-60', label: '45-60 min' },
    { value: '60+', label: 'Over 60 min' }
  ];

  const equipmentOptions = [
    { value: 'all', label: 'Any Equipment' },
    { value: 'none', label: 'No Equipment' },
    { value: 'dumbbells', label: 'Dumbbells' },
    { value: 'barbell', label: 'Barbell' },
    { value: 'resistance-bands', label: 'Resistance Bands' },
    { value: 'kettlebell', label: 'Kettlebell' },
    { value: 'machine', label: 'Machine' }
  ];

  const hasActiveFilters = filters?.category !== 'all' || 
                          filters?.difficulty !== 'all' || 
                          filters?.duration !== 'all' || 
                          filters?.equipment !== 'all' ||
                          filters?.search !== '';

  return (
    <>
      <button
        onClick={onToggle}
        className="lg:hidden flex items-center justify-between w-full px-4 py-3 bg-card border border-border rounded-lg shadow-sm mb-4 press-scale"
        aria-label="Toggle filters"
        aria-expanded={isOpen}
      >
        <div className="flex items-center gap-2">
          <Icon name="SlidersHorizontal" size={20} color="var(--color-primary)" />
          <span className="font-medium text-foreground">Filters</span>
          {hasActiveFilters && (
            <span className="flex items-center justify-center w-5 h-5 bg-accent text-accent-foreground rounded-full text-xs font-bold">
              {[filters?.category, filters?.difficulty, filters?.duration, filters?.equipment]?.filter(f => f !== 'all')?.length}
            </span>
          )}
        </div>
        <Icon 
          name={isOpen ? "ChevronUp" : "ChevronDown"} 
          size={20} 
          color="var(--color-muted-foreground)" 
        />
      </button>
      <div className={`
        lg:block bg-card border border-border rounded-xl shadow-md p-4 md:p-5 lg:p-6
        ${isOpen ? 'block' : 'hidden'}
      `}>
        <div className="flex items-center justify-between mb-4 lg:mb-6">
          <h2 className="text-lg md:text-xl font-heading font-semibold text-foreground">
            Filter Workouts
          </h2>
          {hasActiveFilters && (
            <Button
              variant="ghost"
              size="sm"
              iconName="X"
              iconPosition="left"
              onClick={onClearFilters}
            >
              Clear All
            </Button>
          )}
        </div>

        <div className="space-y-4">
          <Input
            type="search"
            placeholder="Search workouts..."
            value={filters?.search}
            onChange={(e) => onFilterChange('search', e?.target?.value)}
            className="w-full"
          />

          <Select
            label="Category"
            options={categoryOptions}
            value={filters?.category}
            onChange={(value) => onFilterChange('category', value)}
          />

          <Select
            label="Difficulty Level"
            options={difficultyOptions}
            value={filters?.difficulty}
            onChange={(value) => onFilterChange('difficulty', value)}
          />

          <Select
            label="Duration"
            options={durationOptions}
            value={filters?.duration}
            onChange={(value) => onFilterChange('duration', value)}
          />

          <Select
            label="Equipment"
            options={equipmentOptions}
            value={filters?.equipment}
            onChange={(value) => onFilterChange('equipment', value)}
          />
        </div>

        <div className="mt-6 pt-4 border-t border-border">
          <div className="flex items-center justify-between">
            <span className="text-sm text-muted-foreground">
              Showing <span className="font-semibold data-text text-foreground">{resultCount}</span> workouts
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default FilterPanel;